const patterns = {
    PASSWORD: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[!@#$%^&*]).{0,}$/,
    PROJECT_NAME: /^[a-zA-Z][a-zA-Z0-9_]{0,62}$/
}

export default patterns;